import Lenis from 'lenis';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class ScrollManager {
  constructor() {
    this.lenis = null;
    this.rafCallback = null;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    this.init();
    // lagSmoothing(0)はLenis連携時のみ必要。Safari（Lenisなし）では
    // デフォルトの補正を維持しないとScrollTriggerのpin計算がずれる
    if (this.lenis) {
      gsap.ticker.lagSmoothing(0);
    }
    this.observeBodyScroll();
  }

  init() {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
      // ScrollTriggerはネイティブscrollイベントを自動リッスンし、
      // Safari向けには即座にupdateAllを呼ぶ仕組みが内蔵されている。
      // 明示的なScrollTrigger.update()は二重更新になるため不要。
      return;
    }

    this.lenis = new Lenis({
      duration: 1.8,
      smoothTouch: false,
      autoRaf: false,
    });

    this.lenis.on('scroll', () => {
      ScrollTrigger.update();
    });

    this.rafCallback = (time) => {
      this.lenis.raf(time * 1000);
    };
    gsap.ticker.add(this.rafCallback);

    window.__lenis = this.lenis;
  }

  stop() {
    if (this.lenis) {
      this.lenis.stop();
    }
  }

  start() {
    if (this.lenis) {
      this.lenis.start();
    }
  }

  observeBodyScroll() {
    const observer = new MutationObserver(() => {
      const isLocked = document.body.style.overflow === 'hidden';
      if (isLocked) {
        this.stop();
      } else {
        this.start();
      }
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['style'],
    });
  }
}
